// extracted by mini-css-extract-plugin
export default {"mainPage":"MainPage_mainPage__QWXtg","header":"MainPage_header__TrN2k","content":"MainPage_content__wQQai"};